import currency from 'currency.js';

export const numeroAMultiplicador = num => {
  switch (num) {
    case 1:
      return 'única';
    case 2:
      return 'doble';
    case 3:
      return 'triple';
    case 4:
      return 'cuádruple';
    case 5:
      return 'quíntuple';
    case 6:
      return 'séxtupla';
    case 7:
      return 'séptupla';
    case 8:
      return 'óctuple';
    case 9:
      return 'nónuple';
    case 10:
      return 'décuple';

    default:
      return num;
  }
};

export const numberOfDays = (inicio, fin) => {
  var d1 = new Date(inicio);
  var d2 = new Date(fin);
  return (d2 - d1) / (1000 * 3600 * 24);
};

export function roundNumbers(value, precision) {
  const factor = Math.pow(10, precision);
  return Math.round(value * factor) / factor;
}

export function formatPrice(value) {
  const numberCurrency = currency(value);

  if (numberCurrency.cents() === 0) {
    return numberCurrency.dollars().toString();
  } else {
    return numberCurrency.toString();
  }
}

/**
 * Calcula el valor resultante de aplicar un porcentaje a una cantidad base
 * @param {number} porcentaje - El porcentaje a aplicar
 * @param {number} cantidadBase - La cantidad base sobre la cual calcular el porcentaje
 * @returns {number} El valor calculado
 */
export function calcularPorcentaje(porcentaje, cantidadBase) {
  return (porcentaje * cantidadBase) / 100;
}
